import { Tank } from 'src/types/ViewModel/Vessel/Tank';
import { DeckTank, TankSideEnum } from 'src/types/ViewModel/Vessel/TankPlan';

interface TankPosition {
    offset: number;
    width: number;
}

const calculateDeckTankPosition = (deckTank: DeckTank, firstTank: Tank, lastTank: Tank, previousTank?: Tank): TankPosition => {
    const startOffset = calculateSpacingFromStart(deckTank.tank, firstTank, lastTank);
    const offset = previousTank ? calculateSpacingFromPrev(deckTank.tank, previousTank, firstTank, lastTank) : startOffset;
    const width = calculateTankWidth(deckTank.tank, firstTank, lastTank);

    return { offset, width };
};

const calculateSpacingFromStart = (tank: Tank, firstTank: Tank, lastTank: Tank): number => {
    // TODO: DIVISION-BY-ZERO - Potential division by zero if lastTank.startFrame equals firstTank.startFrame. Should validate denominator is not zero.
    const tankStartPercentile = (tank.startFrame - firstTank.startFrame) / (lastTank.startFrame - firstTank.startFrame);
    return tankStartPercentile * 100;
};

const calculateSpacingFromPrev = (currentTank: Tank, previousTank: Tank, firstTank: Tank, lastTank: Tank): number => {
    // TODO: DIVISION-BY-ZERO - Potential division by zero if lastTank.endFrame equals firstTank.startFrame. Should validate denominator is not zero.
    const tankStartPercentile = (currentTank.startFrame - previousTank.endFrame) / (lastTank.endFrame - firstTank.startFrame);
    return tankStartPercentile * 100;
};

const calculateTankWidth = (tank: Tank, firstTank: Tank, lastTank: Tank): number => {
    // TODO: DIVISION-BY-ZERO - Potential division by zero if lastTank.endFrame equals firstTank.startFrame. Should validate denominator is not zero.
    const tankWidthPercentile = (tank.endFrame - tank.startFrame) / (lastTank.endFrame - firstTank.startFrame);
    return tankWidthPercentile * 100;
};

export const calculateDeckTankPositions = (deckTanks: DeckTank[], firstTank: Tank, lastTank: Tank): void => {
    let previousTankPort: Tank | undefined;
    let previousTankStarboard: Tank | undefined;

    deckTanks.forEach((deckTank) => {
        const previousTank = deckTank.tank.side === TankSideEnum.Port ? previousTankPort : previousTankStarboard;

        const position = calculateDeckTankPosition(deckTank, firstTank, lastTank, previousTank);
        deckTank.xOffset = position.offset;
        deckTank.width = position.width;

        if (deckTank.tank.side === TankSideEnum.Port) {
            previousTankPort = deckTank.tank;
        } else if (deckTank.tank.side === TankSideEnum.Starboard) {
            previousTankStarboard = deckTank.tank;
        }
    });
};
